import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/styles";
import { useEffect, useState } from "react";
import CronExp from "./components/CronExp";
import CronReader from "./components/CronReader";
import DayOfMonth from "./fields/DayOfMonth";
import Hour from "./fields/Hour";
import Minute from "./fields/Minute";
import Month from "./fields/Month";
import Period from "./fields/Period";
import Week from "./fields/Week";
import { supportedLanguages } from "./i18n";
import { cronExpState } from "./selector";
import {
	cronExpInputState,
	cronValidationErrorMessageState,
	dayOfMonthState,
	hourState,
	isAdminState,
	localeState,
	minuteState,
	monthState,
	periodState,
	weekState,
} from "./store";
import type { SchedulerProps } from "./types";
import { getPeriodIndex } from "./utils";
import {
	useRecoilValue,
	useSetRecoilState,
	useRecoilState,
	useResetRecoilState,
} from "recoil";

const useStyles = makeStyles({
	box: {
		minHeight: "min-content",
	},
});

export default function CronScheduler(props: SchedulerProps) {
	const { cron, setCron, setCronError, isAdmin, locale, customLocale } = props;
	const classes = useStyles();
	const period = useRecoilValue(periodState);
	const [periodIndex, setPeriodIndex] = useState(0);

	const setCronExp = useSetRecoilState(cronExpState);

	const cronError = useRecoilValue(cronValidationErrorMessageState);
	const setIsAdmin = useSetRecoilState(isAdminState);

	const [cronExpInput, setCronExpInput] = useRecoilState(cronExpInputState);
	const setResolvedLocale = useSetRecoilState(localeState);

	const resetCronExpInput = useResetRecoilState(cronExpInputState);
	const resetMinute = useResetRecoilState(minuteState);
	const resetHour = useResetRecoilState(hourState);
	const resetDayOfMonth = useResetRecoilState(dayOfMonthState);
	const resetDayOfWeek = useResetRecoilState(weekState);
	const resetMonth = useResetRecoilState(monthState);
	const resetPeriod = useResetRecoilState(periodState);

	useEffect(() => {
		setCronError(cronError);
	}, [cronError]);

	useEffect(() => {
		setPeriodIndex(getPeriodIndex(period));
	}, [period]);

	useEffect(() => {
		setCron(cronExpInput);
	}, [cronExpInput]);

	useEffect(() => {
		if (isAdmin) {
			setIsAdmin(isAdmin);
		} else {
			setIsAdmin(false);
		}
	}, [isAdmin]);

	useEffect(() => {
		setCronExpInput(cron);
		return () => {
			setCronExp("0 0 * * 1-5");
			resetCronExpInput();
			resetMinute();
			resetHour();
			resetDayOfMonth();
			resetDayOfWeek();
			resetMonth();
			resetPeriod();
		};
	}, []);

	useEffect(() => {
		if (customLocale) {
			setResolvedLocale(customLocale);
		} else if (locale) {
			setResolvedLocale(supportedLanguages[locale]);
		} else {
			setResolvedLocale(supportedLanguages["en"]);
		}
	}, [locale, customLocale]);

	return (
		<>
			<Box display="flex" flexDirection="column" className={classes.box}>
				<Period />
				{periodIndex > 3 && <Month />}
				{periodIndex > 2 && <DayOfMonth />}
				{periodIndex > 1 && <Week />}
				{periodIndex > 0 && <Hour />}
				<Minute />
				<CronExp />
				{/* <CronReader /> */}
			</Box>
		</>
	);
}
